<div>
	<table
		mat-table
		[dataSource]="dataSource"
		class="dashboard-table rounded-xl border border-grey-lightest w-full"
	>
		<ng-container matColumnDef="date">
			<th mat-header-cell *matHeaderCellDef>Date</th>
			<td mat-cell *matCellDef="let element">
				{{ element?.session_start_time | date: 'shortDate' }}
			</td>
		</ng-container>

		<ng-container matColumnDef="time">
			<th mat-header-cell *matHeaderCellDef>Time</th>
			<td mat-cell *matCellDef="let element">
				{{ element?.session_start_time | date: 'shortTime' }}
			</td>
		</ng-container>

		<ng-container matColumnDef="description">
			<th mat-header-cell *matHeaderCellDef>Description</th>
			<td mat-cell *matCellDef="let element">{{ element?.description }}</td>
		</ng-container>

		<ng-container matColumnDef="user">
			<th mat-header-cell *matHeaderCellDef>User</th>
			<td mat-cell *matCellDef="let element">{{ element?.user_login_name }}</td>
		</ng-container>

		<ng-container matColumnDef="amount">
			<th mat-header-cell *matHeaderCellDef>Amount</th>
			<td mat-cell *matCellDef="let element">
				{{ element?.amount ?? 0 | centsToFixedDollars }}
			</td>
		</ng-container>

		<ng-container matColumnDef="hst">
			<th mat-header-cell *matHeaderCellDef>HST</th>
			<td mat-cell *matCellDef="let element">
				{{ element?.hst_amount ?? 0 | centsToFixedDollars }}
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>

	<div class="flex flex-col items-end">
		<div class="flex">
			<span>HST</span
			><span class="w-28 text-right pr-5">{{
				totalHST | centsToFixedDollars
			}}</span>
		</div>
		<div class="flex font-bold">
			<span>Total</span
			><span class="w-28 text-right pr-5">{{
				total | centsToFixedDollars
			}}</span>
		</div>
	</div>
</div>
